// extracted by mini-css-extract-plugin
export default {"container":"_F-z","innerContainer":"aG-z","multipleLines":"bG-z","heading":"cG-z","content":"dG-z","linkColor":"eG-z"};